/**
 * @fileoverview PUT handler for the "/companies/:company_id/innovation_insiders_opt_in" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdInnovationInsidersOptInCacheKeys } from "./constants";
import type { putCompanyInnovationInsidersOptInProps, CompanyInnovationInsidersOptInResult } from "./types";

export const putCompanyInnovationInsidersOptIn = reactQueryMutationAdapter(
  companiesCompanyIdInnovationInsidersOptInCacheKeys,
  (props: putCompanyInnovationInsidersOptInProps): Promise<CompanyInnovationInsidersOptInResult> => {
    return fetch(
      `/companies/${props.company_id}/innovation_insiders_opt_in`,
      "PUT",
      props,
      {},
      { propagateFetchRequestError: false }
    );
  }
);
